import { render, staticRenderFns } from "./SupportIcon.vue?vue&type=template&id=39c1da62&scoped=true&"
import script from "./SupportIcon.vue?vue&type=script&lang=js&"
export * from "./SupportIcon.vue?vue&type=script&lang=js&"
import style0 from "./SupportIcon.vue?vue&type=style&index=0&id=39c1da62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1da62",
  null
  
)

export default component.exports